/**
 * Hook for reading / subscribing to the restaurant's printer config.
 *
 * Components use this to decide whether to route a print action to the thermal
 * printer or prompt the user to run setup.
 */

import { useEffect, useState, useCallback } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase';

export function usePrinterConfig(restaurantUid) {
  const [config, setConfig] = useState(null);
  const [loading, setLoading] = useState(Boolean(restaurantUid));

  useEffect(() => {
    if (!restaurantUid) {
      setConfig(null);
      setLoading(false);
      return undefined;
    }
    setLoading(true);
    const unsub = onSnapshot(
      doc(db, 'restaurants', restaurantUid),
      (snap) => {
        setConfig(snap.exists() ? (snap.data().printerConfig || null) : null);
        setLoading(false);
      },
      (err) => {
        console.warn('[usePrinterConfig] snapshot error:', err.message);
        setLoading(false);
      }
    );
    return () => unsub();
  }, [restaurantUid]);

  const isConfigured = Boolean(config && config.connectionType);

  const reload = useCallback(() => {
    // onSnapshot auto-updates; this is a no-op retained for API compatibility.
  }, []);

  return { config, isConfigured, loading, reload };
}
